import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineFileRestore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M3.275 6.425v-4.2a1.05 1.05 0 0 1 1.05-1.05h6.825l3.675 3.675v8.925a1.05 1.05 0 0 1-1.05 1.05H9.05" />
      <path d="M1.857 11.102a3.103 3.103 0 1 1 1.033 2.986" />
      <path d="m1.175 9.24.682 1.862 1.8-.31" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineFileRestore;
